import MegaViewLogo from '../Assets/img/logo-megaview-dd-w.svg';
import LandAAcquisitionLogo from '../Assets/img/logo.svg';
import DataDeliLogoWhite from '../Assets/img/logo-DD-W.svg';
import SpaceAeyeLogo from '../Assets/img/logo-spaceaeye.svg';
import DataDeliIncLogo from '../Assets/img/logo-DataDeli.svg';
import TimelineViewIcon from '../Assets/img/icon-timeline.svg';
import DashboardIcon from '../Assets/img/icon-dashboard.svg';
import LandDeformationIcon from '../Assets/img/icon-land-deformation-solid.svg';
import LeakageIcon from '../Assets/img/icon-leakage.svg';
import AOIStartIcon from '../Assets/img/icon-start.svg';
import AOIPauseIcon from '../Assets/img/icon-pause.svg';
import AOIContinueIcon from '../Assets/img/icon-continue.svg';
import AOIStopIcon from '../Assets/img/icon-stop.svg';
import LogoutIcon from '../Assets/img/menu-icon-logout.svg';
import ProfileIcon from '../Assets/img/menu-icon-profile.svg';
import SettingsIcon from '../Assets/img/menu-icon-settings.svg';
import AdminIcon from '../Assets/img/menu-icon-admin.svg';
import TokensIcon from '../Assets/img/icon-tokens.png';
import WalletIcon from '../Assets/img/icon-wallet.svg';
import EventIcon from '../Assets/img/menu-icon-event-image.svg';
import TokensAlertIcon from '../Assets/img/icon-alert-red.svg';
import BillingIcon from '../Assets/img/menu-icon-billing.svg';
import KrishiVigyanLogo from '../Assets/Logos/krishivigyan.png';
import GMRInnovexLogo from '../Assets/Logos/gmrinnovex.png';
import NotesIcon from '../Assets/img/menu-icon-notes.svg';
import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { UserContext } from '../Contexts/UserContext'
import $ from 'jquery';
import { HashLink } from 'react-router-hash-link';
import LogoutTimer from './LogoutTimer';
import Notifications from './Notifications';
import UserViewMenubar from './UserViewMenubar';
import Role from '../Helpers/Role';
import OrgLogo from '../Assets/img/icon-organization.svg';
import OrgChange from '../Assets/img/icon-change.svg';
import { productSettings } from '../Utils/productSettings';

const appConfig = window.config;
const logoNameMapping = {
    'krishivigyan.png': KrishiVigyanLogo,
    'gmrinnovex.png': GMRInnovexLogo
};

const NavBar = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, signOut, openLoginModal, domainConfig, originalUserExpensesPerMonth, showMapMoveOptions, 
        timelineView, setTimelineView, setSelectedTimelineView, resetTimeline, setResetTimeline, selectedOrgId, selectedOrg, showContactUsModal
    } = useContext(UserContext);
    const protectedPages = ["login", "profile", "swagger", "reset-password"];
    const showUserViewInPages = ["portfolio", "timelinev1", "timelinev2", "timeline", "timelinesr", "member"];
    const showUserViewMenu = user.isAuthenticated
        && (user.isCustomerService || user.isDA || user.isAdmin || user.isSuperAdmin)
        && showUserViewInPages.some((page) => location.pathname.includes(page));
    const isHomePage = location.pathname == "/";
    const [distance, setDistance] = useState(100);
    const [selectedPage, setSelectedPage] = useState("");
    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
        if (location.pathname == "/")
            setSelectedPage('homepage');
        else if (location.pathname.startsWith("/timeline"))
            setSelectedPage('timeline');
        else
            setSelectedPage('');
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            setIsFixed(window.scrollY >= 100);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const logout = () => {
        navigate("/");
        signOut();
    };

    const handleMobileMenuClick = () => {
        $('.main-navigation').toggle("");
    };

    const onNavMenuOptionClick = (selectedPage) => {
        setSelectedPage(selectedPage);
        $('.main-navigation').hide();
    }

    const timelineClick = () => {
        setSelectedPage('timeline');
        if (props.mapMoveState == 0)
            setResetTimeline(resetTimeline + 1);
    };

    const onTimelineViewChange = (view) => {
        setSelectedTimelineView(view);
        // Set the timelineView only after saving the mapState(MapState will be saved on selectedTimelineView Change)
        // MapState is required to be saved to retain the map state on timeline view change
        setTimeout(() => {
            setTimelineView(view);
        }, 100);
    }

    const onOrgChangeClick = () => {
        props.setShowSelectOrgModal(true);
    }

    const RenderLogo = () => {
        return <Link to="/" className="navbar-brand">
                        {
                            productSettings.isLandAcquisition 
                            ? <img src={LandAAcquisitionLogo} alt="Land Acquisition" />
                            : <img src={MegaViewLogo} alt="Mega View" />
                        }
                </Link>;
    };

    const LoggedInNavigation = () => {
        if(!user.isAuthenticated)
            return <></>;

        return <>
                    <ul className="main-nav">
                        {
                            selectedOrg != null && !selectedOrg.hideDashboard && 
                            <li><Link to="/dashboard">Dashboard</Link></li>
                        }
                        <li><Link to="/portfolio" className={selectedPage == 'dashboard' ? 'active' : ''} onClick={() => onNavMenuOptionClick('dashboard')}><img src={DashboardIcon} /> Portfolio</Link></li>
                        {
                            selectedPage == 'timeline' && selectedOrg != null && !selectedOrg.hideTimelineViews &&
                            <li className="timeline-active">
                                <Link><img src={TimelineViewIcon} /></Link>
                                {
                                    <select className="timeline-options" value={timelineView} onChange={(e) => setTimelineView(e.target.value)}>
                                        <option value="single">Single View</option>
                                        <option value="slider">Slider View</option>
                                        <option value="comparison">Compare View</option>
                                    </select>
                                }
                            </li>
                        }
                    </ul>
                    <LogoutTimer time={window.expiryTime} />
                </>;
    };

    const GeneralMenu = () => {
        if(productSettings.isMegaView && isHomePage)
            return <></>;

        return <ul className="user-nav main-menus">
                    <li><Link to="https://www.datadeli.in/">Home</Link></li>
                    <li>
                        <Dropdown>
                            <Dropdown.Toggle>
                                Solutions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="https://landacquisition.mega-view.com/" target="_blank">Land Acquisition</Dropdown.Item>
                                <Dropdown.Item href="https://mega-view.com/" target="_blank">Property Monitoring</Dropdown.Item>
                                <Dropdown.Item href="https://spaceaeye.ai/" target="_blank">Oil & Gas Industry</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>

                    <li><a onClick={
                            ()=>showContactUsModal(true, 
                                'Thanks for your interest in our Land Acquisition solution! Let us know how to reach you and we’ll contact you soon.',
                                'Land Acquisition', 
                                'Top Navigation - Contact Us link', )
                            }
                        >Contact Us</a>
                    </li>
                </ul>;
    };

    const UserProfileMenu = () => {
        if(productSettings.isMegaView && isHomePage)
            return <></>;

        if(!user.isAuthenticated) {
            return <div className="top-right">
                        {
                            !protectedPages.some((page) => location.pathname.includes(page)) &&
                            <a onClick={() => openLoginModal(true)}>
                                Sign In
                            </a>
                        }
                    </div>;
        }

        return  <ul className="user-nav">
                    {
                        user?.userRoles?.length > 1 &&
                        <li>
                            <div className='org-selection' onClick={onOrgChangeClick}>
                                <div className='org-name'>
                                    <img src={OrgLogo} alt='' />&nbsp;
                                    <Link>{user?.userRoles?.find(org => org.orgId == selectedOrgId)?.orgName ?? ''}</Link>
                                </div>
                                <a className='org-change-link' >
                                    <img src={OrgChange} alt='' />
                                </a>
                            </div>
                        </li>
                    }
                    <li className="profile">
                        <Dropdown>
                            <Dropdown.Toggle id="profileMenus">
                                <i className="user"></i>
                                <span className="name">{user.name ?? user.email ?? ""}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="profile-ddl">
                                <Dropdown.Item onClick={() => navigate("/profile")}><img src={ProfileIcon} alt='' />Profile</Dropdown.Item>
                                <Dropdown.Item onClick={() => navigate("/settings")}><img src={SettingsIcon} alt='' />Settings</Dropdown.Item>
                                {
                                    Role.isAdmin(user.role) &&
                                    <>
                                        <Dropdown.Item onClick={() => navigate("/members")}><img src={AdminIcon} alt='' />Members</Dropdown.Item>
                                        {
                                            !user.isClientUser &&
                                            <Dropdown.Item onClick={() => navigate("/manageevents?view=0")}><img src={EventIcon} alt='' />Events</Dropdown.Item>
                                        }
                                    </>
                                }
                                <Dropdown.Item onClick={() => logout()} className="line"><img src={LogoutIcon} alt='' />Log out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>
                </ul>;
    };

    return (
        <>
            <header className={isHomePage ? (isFixed ? "home-page fixed" : "home-page") : "user-pages"}>
                <div className="mobile-menu" onClick={handleMobileMenuClick}>
                    <i></i>
                </div>

                <nav className="navbar">
                    <div className="top-left">
                        <RenderLogo />
                    </div>
                    <div className="main-navigation">
                        <LoggedInNavigation />
                        <GeneralMenu />
                    </div>
                    <UserProfileMenu />
                </nav>
            </header>
        </>
    );
}

export default NavBar;